<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  export default {
    name: 'UserPagination',
    props: {
      self: [
        Number,
        Boolean,
      ],
      last: [
        Number,
        Boolean,
      ],
      first: [
        Number,
        Boolean,
      ],
      prev: [
        Number,
        Boolean,
      ],
      next: [
        Number,
        Boolean,
      ],
    },
    computed: {
      nextPageDisabled() {
        return this.self === this.last
      },
      prevPageDisabled() {
        return this.self === 1
      },
      lastPageDisabled() {
        return this.self === this.last
      },
    },
    methods: {
      toNext() {
        !this.nextPageDisabled ? this.$emit('changePage', this.next) : false
      },
      toPrev() {
        !this.prevPageDisabled ? this.$emit('changePage', this.prev) : false
      },
      toLast() {
        !this.lastPageDisabled ? this.$emit('changePage', this.last) : false
      },
    },
  }
</script>
